import { createRoot } from 'react-dom/client';
import { App, getCurrentScreen } from './App';
import { CONFIG } from './config';
import { createContentSource } from './content/source';
import { startHeartbeat } from './runtime/heartbeat';
import { initMonitoring, report, setMonitorTag } from './runtime/monitor';
import { registerSW, requestPersistence, waitForController } from './runtime/swUpdate';
import { createAssetStore } from './storage';
import { SyncEngine } from './sync/SyncEngine';
import './styles/index.css';

const root = createRoot(document.getElementById('root') as HTMLElement);

const path = location.pathname.replace(/\/+$/, '');

if (import.meta.env.VITE_SOLO_ASESORES === '1' || path === '/asesores' || path.startsWith('/asesores/')) {
  // Versión responsive para laptops de asesores (chunk aparte; sin sincronización ni kiosko)
  void import('./asesores/Asesores').then(({ Asesores }) => root.render(<Asesores />));
} else if (path === '/diagnostico') {
  // Fase 0: página de diagnóstico (chunk aparte; no arranca la sincronización)
  void import('./diag/Diagnostico').then(({ Diagnostico }) => root.render(<Diagnostico />));
} else {
  void startKiosk();
}

async function startKiosk() {
  await registerSW();
  void requestPersistence();

  const store = await createAssetStore();
  const sync = new SyncEngine({ store, source: createContentSource(), report });

  // Con contenido ya guardado, se espera (máx. 1,5 s) a que el SW controle la página para servir /__asset/
  await waitForController(1500);
  try {
    await sync.boot();
  } catch (e) {
    report(e, { op: 'boot' });
  }

  root.render(<App sync={sync} />);

  sync.start();
  startHeartbeat(sync, getCurrentScreen);
  void initMonitoring(() => ({ app: CONFIG.appVersion, source: CONFIG.source, store: store.kind }));
  sync.subscribe((s) => {
    if (s.activeVersion) setMonitorTag('content', s.activeVersion);
  });
}
